import {
  previous_month_average_cluster_v4,
  previous_month_average_area_v4,
  previous_month_average_branch_v4,
} from "../../v4-services/reports/previous_month_average";
import { actionTypes } from "../action_types";

const defaultPayload = [];

const createPreviousMonthAverageAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data)
      .then((resp) => {
        if (resp.problem === null) {
          dispatch({
            type: actionType,
            payload: resp.data !== null ? resp.data : defaultPayload,
          });
        }
        return Promise.resolve(resp);
      })
      .catch((err) => {
        dispatch({
          type: actionType,
          payload: defaultPayload,
        });
        return Promise.resolve(err);
      });
  };

export const SetPreviousMonthAverageSetScopeDate = (data) => (dispatch) => {
  dispatch({
    type: actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_SET_SCOPE_DATE,
    payload: data,
  });
};

export const GetPreviousMonthAverageClusterV4 =
  createPreviousMonthAverageAction(
    previous_month_average_cluster_v4,
    actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_GET_CLUSTER
  );

export const GetPreviousMonthAverageAreaV4 = createPreviousMonthAverageAction(
  previous_month_average_area_v4,
  actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_GET_AREA
);

export const GetPreviousMonthAverageBranchV4 = createPreviousMonthAverageAction(
  previous_month_average_branch_v4,
  actionTypes.REPORTS_PREVIOUSMONTH_AVERAGE_GET_BRANCH
);
